import React, { useState, useEffect, useContext, useRef } from "react";
import TrackContext from "../../contexts/track-context";
import TrackItem from "../TrackItem";
import API from "../../services/api";
import AddTrackToProjectPopup from "../Projects/addTrackToProjectPopup";
import Helper from "../../services/helper";
import "./style.css";
import { useHistory, useParams } from "react-router-dom";
import { ReactComponent as CloseModal } from "../../assets/modal-close.svg";
import RippleLoader from "../../assets/loader-2.gif";
import Amplitude from "amplitudejs";
import { Pause } from "@material-ui/icons";
import { PlayArrow } from "@material-ui/icons";
import "./style.css";
import { BouncingLoader } from '../../pure-components/Loader';
import { BouncingLoader2 } from '../../pure-components/Loader';
import Constants from "../../services/constants";
import { toast } from "react-toastify";
import { ErrorToast } from "../../pure-components/CustomToast";
import defaultImage from "../../assets/default_music.png";
import Track from "../Track";
import HarvestService from "../../services/harvestService";

const AlbumDetails = (props) => {
  let ref = useRef(null);
  let trackContext = useContext(TrackContext);
  const history=useHistory()
  const [albumData, setAlbumData] = useState([]);
  const [albumDetails, setAlbumDetails] = useState();
  const [noDataFound, setNoDataFound] = useState(false);
  const [showProjectModal, setShowProjectModal] = useState(false);
  const [trackToBeAddedToProject, setTrackToBeAddedToProject] = useState("");
  const [loaderAddTrackToProject, setLoaderAddTrackToProject] = useState(false);
  const [expandedTrackId, setExpandedTrackId] = useState("");
  const [playAll,setPlayAll]=useState(false);
  const [loading, setLoading] = useState(false);
  const [isFetching,setisFetching]=useState(false);
  const pageId='album'

  const [initialized, setInitialized] = useState(false);
  const [marginTop, setMarginTop] = useState("20px");
  const [isMobile, setIsMobile] = useState(false);
  const {albumId}=useParams();
  
  const [downloadingTracks, setDownloadingTracks] = useState([]);
  const [favingTracks, setFavingTracks] = useState([]);

  useEffect(() =>{

    (async() => {
      await loadAlbumData().finally(() => {
        setLoading(false);
      });
    })();

    // set the margin of playbutton

    const updateMargin = () => {
      if (window.innerWidth < 768) {
        setMarginTop("-10px"); // Mobile view
      } else if (window.innerWidth < 1024) {
        setMarginTop("-50px"); // Tablet view
      } else {
        setMarginTop("-50px"); // Desktop view
      }
    };

    updateMargin(); // Set initial value
    window.addEventListener("resize", updateMargin);

    return () => {
      window.removeEventListener("resize", updateMargin);
    }
  }, [albumId]);

  useEffect(() => {
    // console.log("Album details  : ", albumDetails);
  }, [albumDetails])
  const loadAlbumData = async() => {
    setLoading(true);
    const album = {};
    const reqObj = {
            refUrl : `/getalbum/{memberToken}/${albumId}`, 
            method : 'get',
            headers : {
              "Accept" : "application/json",
              'Content-Type': 'application/json',
              'Cache-Control': 'no-cache',
              'Pragma': 'no-cache',
              'Expires': '0',
            }
          };
    await HarvestService.loadHarvestData(reqObj).then((resp) => {
      // console.log("Album data resp : ", resp);
      album.albumData = resp.Album;
    }).catch((err) => {
      setNoDataFound(true);
      console.log("Album data Loading Error : ", err);
      toast(({ closeToast }) => <ErrorToast message={"Album data loading Error."} />);
    })

    const reqObj1 = {
            refUrl : `/getalbumtracks/{memberToken}/${albumId}/mainonly`, 
            method : 'get',
            headers : {
              "Accept" : "application/json",
              'Content-Type': 'application/json',
              'Cache-Control': 'no-cache',
              'Pragma': 'no-cache',
              'Expires': '0',
            }
          };
    await HarvestService.loadHarvestData(reqObj1).then((resp) => {
      // console.log("Album track data resp : ", resp);
      album.albumTracks =  resp.Tracks;
    }).catch((err) => {
      setNoDataFound(true);
      console.log("Album tracks data Loading Error : ", err);
      toast(({ closeToast }) => <ErrorToast message={"Album tracks data loading Error."} />);
    })
    setAlbumDetails(album);
  }

  // const clearFilter = async() => {
  //   trackContext.setTrackData([]);
  //   let filter=trackContext.trackFilter;
  //   filter.searchTitle="";
  //   trackContext.setTrackFilter(filter);
  //   if (trackContext.path.startsWith("/album/")
  //   ) {
  //    localStorage.setItem("filter_album", JSON.stringify(filter)); 
  //   }
  //   history.push( `/album/${albumId}`)
  //   await getAlbumDetails();
  //   await getAllAlbumTrack();
  // };

  // const getAllAlbumTrack=async()=>{
  //      setLoading(true);
  //   if(allTracksLoaded)
  //     return;

  //   //setting loader only for first time ie. page no : 0
  //   pageNo === 0 && trackContext.setIsLoading(true);

  //   let reqObj = { 
  //     url : `public/albums/${albumId}/tracks?page=${pageNo}&max=${Constants.ALBUM_TRACKS_DEFAULT_PAGE_SIZE}`,
  //     method : 'get'
  //   };

  //   await MewoService.loadMewoData(reqObj).then(res => {
  //   // await API.getAllAlbumTracks(albumId, pageNo).then(res => {
  //     if(res?.data?.length)
  //     {
  //       let originals = res.data.filter(elem => {return elem?.version?.key === "original"});
  //       setAlbumData([...albumData, ...originals]);
  //       trackContext.setTrackData(res.data);
  //       trackContext.setSongData(res.data)
  //     }
  //     else if(!albumData){
  //       setNoDataFound(true);
  //     }
  //     //if list length is less than page size, its last page
  //     if(res?.data?.length < Constants.ALBUM_TRACKS_DEFAULT_PAGE_SIZE){
  //       setAllTracksLoaded(true);
  //     }else{
  //       setPageNo(pageNo + 1);
  //     }
  //     trackContext.setIsLoading(false);
  //     setInitialized(true)
  //     setLoading(false);

  //     setLoadMore(false)
  //   }).catch((err) => {
  //     trackContext.setIsLoading(false);
  //     setInitialized(true)
  //     setAllTracksLoaded(true);
  //     toast(({ closeToast }) => <ErrorToast message={"Album Tracks Loading Error : " + err?.response?.data?.message}/>);
  //   })
  // }

  // const getAlbumDetails=async()=>{
  //   setLoading(true);

  //   trackContext.setIsLoading(true);
  //   let reqObj = {
  //     url : `public/albums/${albumId}`,
  //     method : 'get'
  //   };
  //   await MewoService.loadMewoData(reqObj).then(res => {
  //     if(res)
  //       setAlbumDetails(res);
  //     else
  //       setNoDataFound(true);

  //   }).catch((err) => {
  //     trackContext.setIsLoading(false);
  //     setLoading(false);
  //     setInitialized(true)
  //     setAllTracksLoaded(true);
  //     toast(({ closeToast }) => <ErrorToast message={"Album Details Loading Error : " + err?.response?.data?.message}/>);
  //   })
  // };

  // useEffect(()=>{
  //   //to show play or pause button 
  //   let index=albumData?.findIndex((track)=> track.id === trackContext?.currentTrackDetail?.id)
  //   if(index !== -1 && index!==undefined  && trackContext.playPause && trackContext.playingFrom === pageId){
  //     setPlayAll(true)
  //   }
  //   else {
  //     setPlayAll(false)
  //   }
  // },[trackContext.playPause,albumData])

  //to pause current playing track
  const handlePause=()=>{
    setPlayAll(false);
    trackContext.setPlayPause(false);
  }

    //function to fetch track for albums and play tracks
    const playAlbumTracks=async()=>{
      if(trackContext.trackData.length > 0){
        let index=trackContext.trackData.findIndex(track=>track.id === Amplitude.getSongs()[0]?.id)
        if(index !== -1 && trackContext.playingFrom === pageId)
        {
          setPlayAll(true);
          trackContext.setPlayPause(true);
          return
        }
      }

      trackContext.setFetchingTrack(true);
      setisFetching(true)
      await API.playTrack(albumData[0].id).then(res => {
        if(res?.data?.success){
          trackContext.setalltrackData(trackContext.trackData)
          trackContext.setPlayPause(true);
          let index=res.data.id === Amplitude.getSongs()[0]?.id;
          if (Amplitude.getSongs().length && index!==0) {
            Amplitude.stop();
            Amplitude.removeSong(0);
          }
          trackContext.setPlayingFrom(pageId)
          trackContext.setCurrentTrack(res.data.data.audiofile);
          trackContext.setCurrentTrackDetail({...res.data.data,...res.data.data.tags,
            artist: res.data.data.artists_publishing_ownerships[0]?.artist?.full_name,
            artist_type: res.data.data.artists_publishing_ownerships[0]?.rights_type?.key,});
          trackContext.setCurrentTrackImage(res.data.data.album?.image?.xsmall?.url);
          setPlayAll(true);
        }else{
          Helper.handleError(res.data);
        }
        trackContext.setFetchingTrack(false);
        setisFetching(false);
        setLoading(false);
      })
      .catch(err=>{
        Helper.handleError(err);
      })
  }



  const displayProjectModal = (trackId) => {
    setTrackToBeAddedToProject(trackId);
    setShowProjectModal(true);
  };

  const closeProjectModal = () => {
    setShowProjectModal(false);
    setLoaderAddTrackToProject(false);
  };

  // useEffect(() => {
  //   if (ref.current !== null) {
  //     // INTERSECTION OBSERVER
  //     let options = {
  //       root: null,
  //       rootMargin: "0px",
  //       threshold: 1.0,
  //     };
  //     let observer = new IntersectionObserver(loadMoreTracks, options);
  //     let target = document.querySelector("#load-more-tracks");
  //     observer.observe(target);
  //   }
  // });


  // const loadMoreTracks = (entries, observer) => {
  //   // console.log("loading more",allTracksLoaded, loadMore, isLoading)
  //   entries.map((entry) => {
  //     if (entry.isIntersecting) {
  //       if (allTracksLoaded) {
  //         setLoadMore(false);
  //       } else {
  //         setLoadMore(true);
  //       }
  //     }
  //   });
  // };

  // useEffect(() => {
  //   if(loadMore){
  //     (async()=>{
  //       await getAllAlbumTrack();
  //     })()
  //   }
  // },[loadMore])

    
    useEffect(() => {
      const checkScreenSize = () => {
        setIsMobile(window.innerWidth <= 480);
      };
  
      checkScreenSize(); // Initial check
      window.addEventListener('resize', checkScreenSize);
  
      return () => window.removeEventListener('resize', checkScreenSize);
    }, []);
  
    const ResponsiveLoading = ({ isMobile }) => (
      <>
        <div className="row" />
        {isMobile ? <BouncingLoader2 /> : <BouncingLoader />}
      </>
    );  
  const getComposers = (compNames) => {
    const tempData = {};
    if(compNames?.length > 0){
      const arr = compNames.split(",");
      arr?.length > 1 && arr.forEach((elem, idx) => {
        tempData[idx] = elem;
      });
      arr?.length === 1 && (() => {tempData["1"] = arr[0]})();
    }
    return tempData;
  }
  return (
    <>
      <div 
        className=" sm:flex sm:flex-col sm:w-full lg:mx-auto p-2 rounded-2xl" 
        // style={{"backgroundImage": `url(${Helper.getLargeArtworkURL(albumDetails?.albumData?.ID)})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat', minHeight: '100vh', width: '100%'}}
        style={{ background: "rgb(var(--bg))", color: "rgb(var(--text))", minHeight: "80vh", maxHeight : "80vh", overflowY:"scroll" }}
        >
        {noDataFound && (
          <div className="text-xl text-center text-red-500">
            No Data Found
          </div>
        )}
       
        {loading ? (
  <div className="w-full flex justify-center items-end"
  style={{height:"40vh"}}
  >
      <ResponsiveLoading isMobile={isMobile} />
    {/* <BouncingLoader /> */}
  </div>
) : (
  albumDetails?.albumData && (
    <div className="pb-1 border-b lg:mt-0">
      <div className="w-full flex flex-col gap-y-2 md:flex-row md:gap-y-0 py-6 md:py-2">
        <div className="w-full lg:w-2/12 rounded-md">
          <img
            src={Helper.getArtworkURL(albumDetails?.albumData?.ID) || defaultImage}
            alt=""
            onError={(e) => {     e.target.onerror = null;     e.target.src = defaultImage   }}
            className="w-full border-2"
            loading="lazy"
            style={{ boxShadow: "4px 4px 12px rgb(var(--shadow))"}}
          />
        </div>
        <div className="w-full lg:w-10/12 text-left lg:pl-5">
          <div 
            // style={{"background": "white", "padding": "4px"}}
            style={{ color: "rgb(var(--text))", "marginTop": "-6px"}}
            >
            <span className="album-header">{albumDetails?.albumData?.Name || albumDetails?.albumData?.DisplayTitle}</span>
            {/* Not present in response object  */}
            {/* <h1 className="mb-1 sm:flex text-albuminfo text-sm">
              Album by{" "}
              <span className="text-albuminfo-data flex-row self-center text-all">
                {Helper.getArtistName(albumDetails?.display_artists)?.toLowerCase()}
              </span>
            </h1> */}
            <div className="mt-2 mb-1 sm:flex t-artist">
              Label&nbsp;&nbsp;:&nbsp;&nbsp;{" "}
              <span className="flex-row self-center text-all">
                {albumDetails?.albumData?.LibraryName}
              </span>
            </div><div className="mb-2 sm:flex t-artist">
              Code&nbsp;&nbsp;:&nbsp;&nbsp;{" "}
              <span className="flex-row self-center text-all">
                {albumDetails?.albumData?.Code}
              </span>
            </div>

            {/* <h1 className="mb-1 sm:flex text-albuminfo text-sm">
              Track Count:{" "}
              <span className="text-albuminfo-data flex-row self-center text-all">
                {albumDetails?.albumData?.TrackCount}
              </span>
            </h1> */}
            {/* <h1 className="w-full lg:w-3/5 text-justify text-description flex-row self-center text-all">
              {albumDetails?.descriptions[0]?.value}
            </h1> */}
            <p className="w-full text-left notify-text"
                title={albumDetails?.albumData?.Detail}
            >
              {albumDetails?.albumData?.Detail}
            </p>
          </div>
        </div>
      </div>

      {/* <div className="w-full row" style={{ marginTop }}>
        <div className=" w-0 sm::w-full lg:w-3/12"></div>
        <div className="w-full lg:w-9/12 px-3 pl-2 sm:pl-10">
          <div className="w-full">
            <div className="cursor-pointer album-button-container">
              {!playAll ? (
                <button disabled={isFetching} className="album-play-button" onClick={playAlbumTracks}>
                  <span>
                    <PlayArrow className="outline-none cursor-pointer" />
                  </span>
                  <span>Play</span>
                </button>
              ) : (
                <button className="album-pause-button" onClick={handlePause}>
                  <span>
                    <Pause className="outline-none cursor-pointer" />
                  </span>
                  <span>Pause</span>
                </button>
              )}
            </div>
          </div>
        </div>
      </div> */}
    </div>
  )
)}

        <div className="w-full  sm:flex sm:flex-wrap  justify-center">
        {(!loading && (!albumDetails?.albumTracks || albumDetails?.albumTracks?.length === 0)) && (
          <div className="text-xl text-center text-red-500 mt-4">
            No Track Data Found
          </div>
        )}
        {
          !loading && albumDetails?.albumTracks?.length > 0 && albumDetails?.albumTracks?.map((track, index, arr) => {
            return (
              
                <Track
                  // tags={track.tags}
                  image={Helper.getArtworkURL(albumDetails.albumData.ID)}
                  key={track.ID}
                  albumId={track.AlbumID}
                  title={track.DisplayTitle || track.Name}
                  duration={track.LengthSeconds}
                  bpm={track.Bpm}
                  versions={track.AlternateCount}
                  producer={track.Publisher}
                  artistName={
                    track.Composer
                  }
                  album={track.AlbumName}
                  trackId={track.ID}
                  waveform={Helper.getWaveformURL(track.ID)}
                  // setTrackUrl={props.setTrackUrl}
                  // setFetchingTrack={trackContext.setFetchingTrack}
                  // changeCurrentTrackImage={props.changeCurrentTrackImage}
                  displayProjectModal={displayProjectModal}
                  // handleCurrentTrackDetail={props.handleCurrentTrackDetail}
                  // similarity={track?.similarity}
                  description={track?.Comment}
                  expandedTrackId={expandedTrackId}
                  setExpandedTrackId={setExpandedTrackId}
                  pageId={pageId}
                  artists={
                    Helper.getComposers(track.Composers)
                  }

                  downloadingTracks = {downloadingTracks}
                  setDownloadingTracks = {setDownloadingTracks}
                  favingTracks = {favingTracks}
                  setFavingTracks = {setFavingTracks}

                  lyrics = {track.Lyrics || ""}
                />
              
              )
          })
        }
        </div>
        
        {showProjectModal && (
            <AddTrackToProjectPopup
              trackToBeAddedToProject={trackToBeAddedToProject}
              closeProjectModal={closeProjectModal}
            />
          )}
       
      </div>
    </>
  );
};

export default AlbumDetails;